export default class HomeView
{
	constructor () {
		$('.section-nav a').on('click', ev => {
			ev.preventDefault()

			let $section = $(ev.delegateTarget).parents('.section')
			let showText = $(ev.delegateTarget).attr('href').substr(1)

			$section.find('.section-content:first > .section-text').addClass('hidden')
			$section.find(`.section-content:first > .section-text.${showText}`).removeClass('hidden')

			$section.find('.section-nav a').removeClass('selected')
			$(ev.delegateTarget).addClass('selected')
		})

		this.initSlider()
	}

	initSlider () {
		this.currentSlide = 1
		this.slidesCount = 3

		$('.show-screenshot').on('click', ev => {
			ev.preventDefault()
			this.showSlide($(ev.target).data('target'))
		})

		$('.screenshot').on('click', ev => {
			this.showNextSlide()
		})
	}

	showSlide (nextSlide) {
		$('.screenshot').not(`.screenshot-${this.currentSlide}`).css('z-index', 1)
		$(`.screenshot-${this.currentSlide}`).css('z-index', 2).animate({ opacity: 0 }, 666)
		$(`.screenshot-${nextSlide}`).css('z-index', 3).animate({ opacity: 1 }, 666)

		$('.show-screenshot').removeClass('shown')
		$(`.show-screenshot[data-target="${nextSlide}"]`).addClass('shown')

		this.currentSlide = nextSlide
	}

	showNextSlide () {
		let nextSlide = this.currentSlide + 1

		if (nextSlide > this.slidesCount) nextSlide = 1

		this.showSlide(nextSlide)
	}
}
